import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";

import { Facility } from "./../../resources";

@Injectable()
export class FacilityService extends BaseDataService<Facility> {
  constructor(http: HttpService) {
    super(http, "facility");
  }

  createInstance(options: any): Facility {
    return new Facility(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
